module.exports = __webpack_public_path__ + "static/media/network.1413f138.jpg";